@if (ref) {
  <div [style.font-size.px]="zoomLevel | fontSizeZoomLevel"
    class="position-absolute w-auto font-weight-bold no-select z-index-100 top-left text-left">
    <span class="reference" [ngClass]="{'reference-badge-selected': selected, 'reference-badge': !selected}">{{ref}}</span>
  </div>
}
